import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getCreditNotes } from "api/creditNote.api";
import { gracefulList } from "lib/queryHelpers";
import { QUERY_KEYS } from "config/queryKeys";
import { DEFAULT_STALE_TIME } from "config/constants";

export const useGetCreditNotes = () => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: QUERY_KEYS.creditNotes.list(),
    queryFn: gracefulList(getCreditNotes, { creditNotes: [] }),
    initialData: () =>
      queryClient.getQueryData(QUERY_KEYS.creditNotes.list()),
    select: (data) => data?.creditNotes ?? [],
    staleTime: DEFAULT_STALE_TIME,
  });
};